

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "../../utils/AxiosInstance";
import "./auth.css";

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Minimum 6 characters")
      .required("Password is required"),
  });

  const handleLogin = async (values, { setSubmitting, resetForm }) => {
    setLoading(true);
    try {
      const res = await axios.post("/auth/admin/login", values);
      if (res.status === 200) {
        localStorage.setItem("token", res.data.data.token);
        toast.success(res?.data?.message);
        navigate("/admin-dashboard");
        resetForm();
      }
    } catch (err) {
      const msg = err.response?.data?.message || "Login failed";
      toast.error(msg);
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/admin-dashboard");
    }
  }, []);

  return (
    <div className="login-one">
      <div className="login-container">
        <div className="login-card">
          <h2 className="login-header">Admin Login</h2>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleLogin}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <Field
                    type="email"
                    name="email"
                    id="email"
                    autoComplete="username"
                    className="styled-field"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="error-text"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <div className="password-wrapper">
                    <Field
                      name="password"
                      id="password"
                      type={showPassword ? "text" : "password"}
                      autoComplete="current-password"
                      className="styled-field"
                    />
                    <button
                      type="button"
                      className="toggle-password"
                      onClick={() => setShowPassword(!showPassword)}
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="error-text"
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting || loading}
                  className="submit-button"
                >
                  {loading ? "Please wait..." : "Login"}
                </button>

                <div className="extra-links">
                  <Link to="/forgot-password" className="styled-link">
                    Forgot password?
                  </Link>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Login;
